import React from 'react'

import DatePicker from 'react-16-bootstrap-date-picker'

export default class RetnDate extends React.Component {

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)

  }

  handleChange(value) {
    console.log("date", value);
    this.props.handleDateChange(value)
  }

  render() {
      let inputValue
      if(typeof this.props.retn !== "undefined") {
        inputValue = this.props.retn.date
      }

    return <DatePicker value={inputValue} onChange={this.handleChange} dateFormat="DD-MM-YYYY" showClearButton={false} />
  }
}



// WEBPACK FOOTER //
// ./src/components/credit/rowelements/retndate.js